import { render } from "./StoreRequisitionList.vue?vue&type=template&id=6f703728&scoped=true"
import script from "./StoreRequisitionList.vue?vue&type=script&lang=js"
export * from "./StoreRequisitionList.vue?vue&type=script&lang=js"

import "./StoreRequisitionList.vue?vue&type=style&index=0&id=6f703728&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f703728"]])

export default __exports__